import gallery from "../../apis/gallery";

export default {
    createGallery({ }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await gallery.add(payload);
                resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    },

    getAllGalleries({ }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await gallery.allGalleries(payload);
                resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    },

    getGalleryById({ }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await gallery.getGalleryById(payload);
                resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    },

    getAllAlbums({ }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await gallery.all(payload);
                resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    },

    getAlbumById({ }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await gallery.getAlbumById(payload);
                resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    },

    editAlbumData({ }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await gallery.edit(payload);
                resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    },

    deleteGallery({ }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await gallery.delete(payload);
                resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    },

    removeImage({ }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await gallery.removeImage(payload);
                resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    },

}